/**
 * Renders the startup preloader during GET /auth/me.
 */

import { useAuth } from '@contexts/AuthContext';
import { GlobalPreloader } from '@components/GlobalPreloader';

export function AuthLoadingOverlay() {
  const { authLoading } = useAuth();

  if (!authLoading) return null;

  return <GlobalPreloader />;
}
